import React, { useEffect, useState } from "react";
import Header from "./Header";
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import axiosInstance from "../../axios/axios";
import { Link } from "react-router-dom";

const AdminOrg = () => {
  const [org, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchAdminJobs = async () => {
      try {
        const res = await axiosInstance.get("all_orgs_admin_View");
        const foundOrgs = res.data.organizations;

        setOrgs(foundOrgs);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminJobs();
  }, []);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const totalPages = Math.ceil(org.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = org.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate page numbers to show
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5; // Max pages to show before using ellipsis

    if (totalPages <= maxVisiblePages) {
      // If total pages is less than max visible, show all
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      // Calculate start and end of visible page numbers
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Add ellipsis after first page if needed
      if (startPage > 2) {
        pageNumbers.push("...");
      }

      // Add middle pages
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }

      // Always show last page
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };
  return (
    <div>
      <Header />
      <div className="my-6 container-md">
        <h1 className="font-bold text-2xl mb-6">Organisations</h1>

        <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6">
          {loading
            ? "Loading..."
            : currentItems.map((each) => (
                <div key={each.id} className="flex flex-col justify-between">
                  <div className="border rounded-md p-2">
                    <p>Name: {each.organization.company_name}</p>
                    <p className="break-words">Email: {each.email}</p>
                    <p>Address: {each.organization.company_street_address}</p>
                    <p>Location: {each.organization.company_state}</p>
                    <p>CAC: {each.organization.company_cac_number}</p>
                  </div>
                  <Link to={`/adminorg/details/${each.organization.id}`}>
                    <button className="w-full text-center border-[#FFC130] border-1 rounded-md font-semibold mt-4 py-2 hover:bg-gray-200">
                      View Org
                    </button>
                  </Link>
                </div>
              ))}
        </div>
        {/* Pagination */}
        <div className="flex justify-center items-center space-x-2 mt-8">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-2 rounded-md ${
              currentPage === 1
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            <FaArrowLeft />
          </button>

          {getPageNumbers().map((number, index) =>
            number === "..." ? (
              <span key={index} className="px-2 py-1">
                ...
              </span>
            ) : (
              <button
                key={index}
                onClick={() => paginate(number)}
                className={`px-3 py-1 rounded-md ${
                  currentPage === number
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                {number}
              </button>
            )
          )}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-2 rounded-md ${
              currentPage === totalPages
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminOrg;
